var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-width":"80%"}},[_c('h1',{staticClass:"grey--text text--darken-2"},[_vm._v("Пользователи")])])}]

export { render, staticRenderFns }